import Backbone from 'backbone'
import _ from 'lodash'
import DatasetsDateFilterPicker from 'scoreboard/datasets/filters/datasets-date-filter-picker'
import FormView from 'scoreboard/components/form-view'

const DatePickerTooltip = Backbone.View.extend({
	tagName: 'form',

	initialize(options = {}) {
		this.options = options

		this.formView = new FormView({
			el: this.el,
			guard: false
		})

		this.picker = new DatasetsDateFilterPicker(_.extend({
			formView: this.formView,
			allowAllTime: true,
			allowAppCalendar: true,
			allowIncomplete: true,
			allowChooseByDay: this.options.filter.operator !== 'in-period'
		}, this.options))
	},

	render: function () {
		this.$el.append(this.picker.el)
		this.picker.render()

		this.formView.start({ isNew: false })

		this.listenTo(this.formView, 'change', () => {
			this.trigger('change')
		})

		this.listenTo(this.picker, 'change', () => {
			this.trigger('change')
		})

		this.listenTo(this.picker, 'equationDialog:open', () => {
			this.trigger('equationDialog:open')
		})

		this.listenTo(this.picker, 'equationDialog:close', () => {
			this.trigger('equationDialog:close')
		})

		return this
	},

	val: function () {
		return this.picker.val()
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([ this.picker, this.formView ], 'remove')
	}
})

export default DatePickerTooltip

DatePickerTooltip.__filename__ = 'dashboards/widgets/dataset-filter/date-picker-tooltip.js'
